"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var CustomRange = /** @class */ (function () {
    function CustomRange() {
    }
    CustomRange.prototype.onLoadEach = function ($element) {
        var _this = this;
        var $input = $element.querySelector("input");
        var $labelValue = $element.querySelector(".CustomRange__range-wrapper__current-value");
        this.applyFill($input, $labelValue);
        (0, rxjs_1.fromEvent)($input, "input").subscribe(function () {
            _this.applyFill($input, $labelValue);
        });
    };
    CustomRange.prototype.applyFill = function ($input, $labelValue) {
        var value = $input.value, min = $input.min, max = $input.max;
        var percentage = (100 * (+value - +min)) / (+max - +min);
        var bg = "linear-gradient(90deg, #f8663c ".concat(percentage, "%, #f6f6f6 ").concat(percentage, "%)");
        $labelValue.innerHTML = "\u20AC ".concat(value);
        $labelValue.style.left = "".concat(percentage, "%");
        $input.style.background = bg;
    };
    CustomRange = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".CustomRange",
            isElementArray: true
        })
    ], CustomRange);
    return CustomRange;
}());
new CustomRange();
